import { useEffect } from 'react'
import { usePageTitle } from '@/hooks/use-page-title'

/**
 * Componente que atualiza o título da página dinamicamente
 * baseado na rota atual. Deve ser usado no root route.
 */
export function PageTitle() {
  const title = usePageTitle()

  useEffect(() => {
    document.title = title
  }, [title])

  return null
}
